import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "swiperWrapper datepickerCarousel" }

import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { ref, watch } from 'vue';
import { formatInTimeZone } from 'date-fns-tz';
import { isValid, parseISO } from 'date-fns';
import { timezone } from '../../envVariables';
import { CarouselDateItem } from '../../Atoms';
import { CarouselDateItemProps } from '../../types';
import { addDays, utcDate, differenceInCalendarDays } from '../..';

import 'swiper/css';
import 'swiper/css/navigation';

const slidesOnOneSide = 10;


export default /*#__PURE__*/_defineComponent({
  __name: 'DatePickerCarousel',
  props: {
    disabled: { type: Boolean },
    datesSelectableBeforeToday: {},
    initialDate: {},
    reinitialiseSwiper: { type: Boolean },
    isLoading: { type: Boolean }
  },
  emits: ['updateDate', 'toggleInitSwiper'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const swiperSlides = ref<typeof Swiper>();
const dates = ref(Array<CarouselDateItemProps>());
const date = ref<string>(props.initialDate);
const datesVisibleBeforeToday = ref(0);
const reinitSwiper = ref(props.reinitialiseSwiper);
const today = utcDate(new Date()).toISOString();
const isSlideDisabled = (slideDate) => (today > slideDate) || props.disabled || false;

let activeIndex;
const createSlide = (slideDate: string, isDisabled: boolean) => ({
  active: +slideDate === +date.value,
  disabled: isDisabled,
  dayOfWeek: formatInTimeZone(slideDate, timezone, 'ccc'),
  dayOfMonth: formatInTimeZone(slideDate, timezone, 'd'),
  month: formatInTimeZone(slideDate, timezone, 'MMM'),
  carouselItemDate: slideDate,
});
const createSlides = (firstDay, totalSlides) => Array.from(
  { length: totalSlides },
  (_, i: number) => {
    const slideDate = addDays(firstDay, i);
    return createSlide(slideDate, isSlideDisabled(slideDate));
  },
);

const silentSlideToActive = () => {
  swiperSlides.value?.slideTo(activeIndex, 0, false);
};

const setNewActiveState = () => {
  dates.value = dates.value.map((d) => ({ ...d, active: false }));
  dates.value[activeIndex].active = true;
};

const initSlides = (newDate) => {
  const daysSinceToday = differenceInCalendarDays(today, newDate);

  const daysOnLeftSide = Math.min(
    daysSinceToday + datesVisibleBeforeToday.value,
    slidesOnOneSide,
  );

  const firstDay = addDays(newDate, -daysOnLeftSide);
  const totalDays = daysOnLeftSide + 1 + slidesOnOneSide;

  activeIndex = daysOnLeftSide;
  dates.value = createSlides(firstDay, totalDays);

  setNewActiveState();
  silentSlideToActive();

  reinitSwiper.value = false;
};

const onSwiper = (swiper) => {
  swiperSlides.value = swiper;

  switch (swiper.currentBreakpoint) {
    case 'max':
      datesVisibleBeforeToday.value = 1;
      break;
    case '420':
      datesVisibleBeforeToday.value = 2;
      break;
    default:
      datesVisibleBeforeToday.value = 3;
  }

  initSlides(date.value);
};

const onSlideChangeTransitionEnd = (swiper) => {
  initSlides(dates.value[swiper.realIndex].carouselItemDate);

  if (reinitSwiper.value) {
    emit('toggleInitSwiper', false);
  } else {
    emit('updateDate', dates.value[swiper.realIndex].carouselItemDate);
  }

  reinitSwiper.value = false;
};

watch([() => props.initialDate, () => props.reinitialiseSwiper], ([newDate, newReinit]) => {
  if (!isValid(parseISO(newDate))) {
    return;
  }

  if (newDate) date.value = newDate;
  if (newReinit) reinitSwiper.value = newReinit;

  if (reinitSwiper.value) {
    initSlides(newDate);
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Swiper), {
      "auto-height": true,
      "slides-per-view": 3,
      "space-between": 5,
      speed: 300,
      navigation: "",
      modules: [_unref(Navigation)],
      breakpoints: {
        '420': {
          slidesPerView: 5,
          spaceBetween: 10,
        },
        '1264': {
          slidesPerView: 7,
          spaceBetween: 0,
        },
      },
      "slide-to-clicked-slide": true,
      "centered-slides": true,
      "centered-slides-bounds": true,
      class: _normalizeClass({ disabled: _ctx.disabled }),
      onSwiper: onSwiper,
      onSlideChangeTransitionEnd: onSlideChangeTransitionEnd
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dates.value, (itemDate, index) => {
          return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
            default: _withCtx(() => [
              _createVNode(_unref(CarouselDateItem), {
                active: itemDate.active,
                disabled: itemDate.disabled,
                "day-of-week": itemDate.dayOfWeek,
                "day-of-month": itemDate.dayOfMonth,
                month: itemDate.month,
                "is-loading": _ctx.isLoading
              }, null, 8, ["active", "disabled", "day-of-week", "day-of-month", "month", "is-loading"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["modules", "class"])
  ]))
}
}

})